import { useState, useEffect } from 'react';
import { Building2, Users, Eye, MapPin, Navigation } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './Dashboard.scss';

const Dashboard = () => {
    const navigate = useNavigate();
    const [year, setYear] = useState(2026);
    const [overview, setOverview] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchOverview();
    }, [year]);

    const fetchOverview = async () => {
        setLoading(true);
        try {
            const response = await api.get('/admin/analytics/overview', { params: { year } });
            if (response.data.success) {
                setOverview(response.data.overview);
            }
        } catch (error) {
            console.error('Error fetching overview:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="loading">Loading dashboard...</div>;
    }

    return (
        <div className="dashboard">
            <div className="dashboard-header">
                <h2>Dashboard Overview</h2>
                <select
                    value={year}
                    onChange={(e) => setYear(Number(e.target.value))}
                    className="year-filter"
                    title="Filter by year"
                >
                    <option value={2026}>2026</option>
                    <option value={2025}>2025</option>
                </select>
            </div>

            {overview && (
                <>
                    <div className="overview-cards">
                        <div className="stat-card" onClick={() => navigate('/mosques')}>
                            <Building2 size={32} />
                            <div>
                                <h3>{overview.totalMosques}</h3>
                                <p>Total Mosques</p>
                            </div>
                        </div>

                        <div className="stat-card">
                            <Users size={32} />
                            <div>
                                <h3>{overview.totalContributors}</h3>
                                <p>Contributors</p>
                            </div>
                        </div>

                        <div className="stat-card" onClick={() => navigate('/analytics')}>
                            <Eye size={32} />
                            <div>
                                <h3>{overview.totalVisits.toLocaleString()}</h3>
                                <p>Total Visits</p>
                            </div>
                        </div>

                        <div className="stat-card">
                            <Navigation size={32} />
                            <div>
                                <h3>{(overview.totalDirectionClicks ?? 0).toLocaleString()}</h3>
                                <p>Directions Clicked</p>
                            </div>
                        </div>

                        <div className="stat-card">
                            <MapPin size={32} />
                            <div>
                                <h3>{overview.topDistricts.length}</h3>
                                <p>Districts</p>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-sections">
                        <div className="section-card">
                            <h3>Recent Activity</h3>
                            <div className="activity-item">
                                <strong>Mosques Added (7 days):</strong> {overview.recentActivity.mosquesAdded}
                            </div>
                            <div className="activity-item">
                                <strong>Visits (7 days):</strong> {overview.recentActivity.visits}
                            </div>
                        </div>

                        <div className="section-card">
                            <h3>Status Breakdown</h3>
                            <div className="status-breakdown">
                                {Object.entries(overview.mosquesByStatus).map(([status, count]) => (
                                    <div key={status} className="status-item">
                                        <span className="status-label">{status}:</span>
                                        <span className="status-count">{count}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="section-card">
                            <h3>Top Districts</h3>
                            <div className="districts-list">
                                {overview.topDistricts.map((district, idx) => (
                                    <div key={idx} className="district-item">
                                        <span>{district.district}</span>
                                        <span>{district.count} mosques</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Dashboard;
